import classNames from "clsx";
import { useVariants } from "./useVariants";

interface Props {
  variants: string[];
  extraClassNames?: string;
  prefix?: string;
}

export const TextWithVariants = ({ variants, extraClassNames, prefix }: Props) => {
  const [variant, incrementIndex] = useVariants(variants);

  return (
    <span
      className={classNames("font-normal text-platform-600 cursor-pointer hover:underline", extraClassNames)}
      data-testid="text-with-variants"
      onClick={incrementIndex}
    >
      {prefix}
      {variant}
    </span>
  );
};
